import { OldApiCaller as ApiCaller } from 'actions/ApiCaller';
import baseAjaxConfig, { savedCardsAjaxConfig, paymentHeaders } from 'actions/BaseAjaxConfig';

const savedVpaHeaders = Object.assign({}, paymentHeaders, {
	Accept: 'application/json',
	'Content-Type': 'application/json'
});
delete savedVpaHeaders['x-device-source'];

export const GET_SAVED_VPA_TOKEN_REQUEST = 'GET_SAVED_VPA_TOKEN_REQUEST';
export const GET_SAVED_VPA_TOKEN_SUCCESS = 'GET_SAVED_VPA_TOKEN_SUCCESS';
export const GET_SAVED_VPA_TOKEN_ERROR = 'GET_SAVED_VPA_TOKEN_ERROR';

export function getSavedVpaTokenRequestAction() {
	return { type: GET_SAVED_VPA_TOKEN_REQUEST };
}

export function getSavedVpaTokenErrorAction() {
	return { type: GET_SAVED_VPA_TOKEN_ERROR };
}

export function getSavedVpaTokenSuccessAction(data) {
	return { type: GET_SAVED_VPA_TOKEN_SUCCESS, data };
}

export function getSavedVpaTokenAction() {
	return dispatch => {
		dispatch(getSavedVpaTokenRequestAction());

		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/1/cards/saved/account-form`,
				acceptErrors: true
			})
		).then(
			json => dispatch(getSavedVpaTokenSuccessAction(json['RESPONSE'])),
			err => {
				dispatch(getSavedVpaTokenErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}

export const GET_SAVED_VPAS_REQUEST = 'GET_SAVED_VPAS_REQUEST';
export const GET_SAVED_VPAS_SUCCESS = 'GET_SAVED_VPAS_SUCCESS';
export const GET_SAVED_VPAS_ERROR = 'GET_SAVED_VPAS_ERROR';

export function getSavedVpaRequestAction() {
	return { type: GET_SAVED_VPAS_REQUEST };
}

export function getSavedVpaErrorAction() {
	return { type: GET_SAVED_VPAS_ERROR };
}

export function getSavedVpaSuccessAction(data) {
	return { type: GET_SAVED_VPAS_SUCCESS, data };
}

export function getSavedVpasAction(payload = {}) {
	return dispatch => {
		dispatch(getSavedVpaRequestAction());
		return ApiCaller.post(
			{
				...savedCardsAjaxConfig,
				headers: savedVpaHeaders,
				pathname: `vpa/view`
			},
			payload
		).then(
			data => dispatch(getSavedVpaSuccessAction(data)),
			err => dispatch(getSavedVpaErrorAction(err))
		);
	};
}

export const DELETE_SAVED_VPA_REQUEST = 'DELETE_SAVED_VPA_REQUEST';
export const DELETE_SAVED_VPA_SUCCESS = 'DELETE_SAVED_VPA_SUCCESS';
export const DELETE_SAVED_VPA_ERROR = 'DELETE_SAVED_VPA_ERROR';

export function deleteSavedVpaRequestAction() {
	return { type: DELETE_SAVED_VPA_REQUEST };
}

export function deleteSavedVpaErrorAction() {
	return { type: DELETE_SAVED_VPA_ERROR };
}

export function deleteSavedVpaSuccessAction() {
	return { type: DELETE_SAVED_VPA_SUCCESS };
}

export function deleteSavedVpaAction(payload) {
	return dispatch => {
		dispatch(deleteSavedVpaRequestAction());
		return ApiCaller.post(
			{
				...savedCardsAjaxConfig,
				headers: savedVpaHeaders,
				pathname: `vpa/delete`,
				acceptErrors: true
			},
			payload
		).then(
			data => dispatch(deleteSavedVpaSuccessAction(data)),
			err => dispatch(deleteSavedVpaErrorAction(err))
		);
	};
}
